import React, { Component } from 'react'
import s from './style.scss'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

class Modal extends Component {

	constructor(props) {
		super(props)

		this.state = {
			hide: false
		}
	}

	render() {

		const { header, list } = this.props

		return <div className={s.container}>

		<div className={s.menu}>
			{header}
		</div>

		<div>
		{list.map(({ link, title, body, footer, active }, key) => (
				<Link to={link} key={key}>
					<div className={classnames(s.box, active && s.active)} >
						<h3>{title}</h3>
						<div>
							{body}
						</div>
						<div className={s.tags}>
							{footer}
						</div>
					</div>
				</Link>
		))}
	</div>

</div>
	}
}

export default Modal


// WEBPACK FOOTER //
// ./src/components/List/index.js